/**
 *
 * Handles playing Youtube video and hiding cover image for Video Player layout
 * 
 * Dev: Mirza Masic
 * Date: 12/17/2019
 * 
 * (note: maybe update in future to handle all embed Youtube videos)
 *
 */

const $        = require( 'jQuery' );

$(document).ready(function(){
  const playVideo = ($element, videoType) => {
    const $root = $element.closest('.itbl-b-video-player');

    $root.find('.itbl-e-video-player-wrap__cover').hide('300');

    if(videoType === 'youtube') {
      $root.find('#itbl-e-video-player-wrap__youtube')[0].src += '&autoplay=1&';
    } else if (videoType === 'vimeo') {
      $root.find('#itbl-e-video-player-wrap__vimeo')[0].play()
    }
  };

  $('.js-video-player-play').on('click', function () {
    var videoType = $('.js-video-player-play').attr('data-video-type');
    playVideo($(this), videoType);
  });

  $('[data-component=video-player-play]').on('click', function (e) {
    const $play = $(e.currentTarget);
    const videoType = $play.data('videotype');
    $play.addClass('slideout');
    playVideo($play, videoType);
  });
});
